import { defineMessages } from 'react-intl';

/** The copy of the master player (design release-kit o). */
export const masterPlayerMessages = defineMessages({
  play: { id: 'app.sml.catalog.song.player.play', defaultMessage: 'Play the master' },
  pause: { id: 'app.sml.catalog.song.player.pause', defaultMessage: 'Pause' },
  seek: { id: 'app.sml.catalog.song.player.seek', defaultMessage: 'Position in the song' },
  position: { id: 'app.sml.catalog.song.player.position', defaultMessage: '{elapsed} of {total}' },
  hook: { id: 'app.sml.catalog.song.player.hook', defaultMessage: 'Hook' },
  goToHook: { id: 'app.sml.catalog.song.player.goToHook', defaultMessage: 'Go to the hook' },
  processing: {
    id: 'app.sml.catalog.song.player.processing',
    defaultMessage: 'The player is ready in about 1 minute.',
  },
  processingDownload: {
    id: 'app.sml.catalog.song.player.processingDownload',
    defaultMessage: 'MUSIC24 reads the song. This takes about 1 minute. You can download the master now.',
  },
  playFailed: {
    id: 'app.sml.catalog.song.player.playFailed',
    defaultMessage: 'MUSIC24 could not play the master. Try again.',
  },
  download: { id: 'app.sml.catalog.song.player.download', defaultMessage: 'Download' },
  downloadLabel: { id: 'app.sml.catalog.song.player.downloadLabel', defaultMessage: 'Download {name}' },
  downloadFailed: {
    id: 'app.sml.catalog.song.player.downloadFailed',
    defaultMessage: 'MUSIC24 could not get the file. Try again.',
  },
  fileMeta: { id: 'app.sml.catalog.song.player.fileMeta', defaultMessage: '{type} · {size} MB' },
});
